import React from 'react';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { Box } from '@cp/ds/src/components/box';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { ChevronRightIcon } from '@cp/ds/src/icons';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import capitalize from 'lodash/capitalize';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { useSubcatalogSpecializationLinks } from 'src/entities/catalog';
import { CatalogSpecializationMenuProps } from './types';

export const CatalogSpecializationMenu: React.FC<CatalogSpecializationMenuProps> = (props) => {
  const theme = useTheme();
  const { links, isLoading: isLoadingLinks } = useSubcatalogSpecializationLinks(props);

  const isLoading = isLoadingLinks;

  return isLoading ? (
    <ContentSkeleton blocks={1} />
  ) : (
    <Box component="ul" sx={{ m: 0, p: 0 }}>
      {links.map(({ key, label, payload, ...restLinkProps }) => (
        <Stack component="li" direction="row" key={key} sx={{ display: 'block' }}>
          <Link
            href={'href' in restLinkProps ? restLinkProps.href : undefined}
            onClick={'onClick' in restLinkProps ? restLinkProps.onClick : undefined}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 2.25,
              borderBottom: `1px solid ${theme.palette['gray middle']}`,
            }}
            underline={false}
          >
            <Typography variant="button secondary">{capitalize(label)}</Typography>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <Typography sx={{ mr: 1 }} variant="body">
                от {payload.minPrice} ₽/час
              </Typography>
              <ChevronRightIcon fontSize="1.5rem" />
            </Stack>
          </Link>
        </Stack>
      ))}
    </Box>
  );
};
